import { getHostConfig, type Environment } from './hostConfig';

export type { Environment };

export const getEnvironment = (): Environment => {
    const { environment } = getHostConfig();

    if (environment) {
        return environment;
    }

    // Fallback for the iframe deployment, where Studio is served from its own
    // origin and the hostname identifies the environment.
    const { hostname } = window.location;

    if (hostname === 'localhost') {
        return 'development';
    }

    if (['.development.', '-dev-', '-dev.'].some((s) => hostname.includes(s))) {
        return 'development';
    }

    if (['.acceptance.', '-stage-', '-stage.'].some((s) => hostname.includes(s))) {
        return 'acceptance';
    }

    return 'production';
};
